import UI from "@mile-meeting/mile-ui";
import { ko } from "date-fns/locale";
import { useEffect, useRef } from "react";
import { Calendar } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const TimeSelectorModal = ({
  open,
  setOpen,
  onChange,
  value,
}: {
  open: boolean;
  setOpen: (value: boolean) => void;
  onChange?: (date: Date) => void;
  value: Date;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const after180Days = new Date();
  after180Days.setDate(after180Days.getDate() + 180);

  useEffect(() => {
    const handler = (event: any) => {
      if (open && ref.current && !ref.current.contains(event.target)) {
        setOpen?.(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [open]);

  return (
    <div
      ref={ref}
      className="calendar-modal"
      style={{
        display: open ? "block" : "none",
        position: "absolute",
        boxShadow: "var(--alias-style-shadow-strong)",
        backgroundColor: "white",
        zIndex: 100,
        width: 356,
        left: 2,
      }}
    >
      <Calendar locale={ko} date={value} onChange={(date) => onChange?.(date)} maxDate={after180Days} />
    </div>
  );
};

export default TimeSelectorModal;
